import type {
  TeaserBaseProps,
  TeaserMediaProps,
  TeaserTextProps,
  TeaserThemeProps,
} from '@bonniernews/dn-design-system-web/assets/types/teaser-props.ts'

import { formatClassString } from '@bonniernews/dn-design-system-web/helpers/formatClassString.ts'
import { Body, Content, Media, Title } from '@bonniernews/dn-design-system-web/helpers/teaser.tsx'

import { TeaserCard } from '@bonniernews/dn-design-system-web/components/teaser-card/teaser-card.tsx'

interface TeaserSlideshowProps extends TeaserBaseProps, TeaserThemeProps, TeaserMediaProps, TeaserTextProps {}

/**
 * - GitHub: [BonnierNews/dn-design-system/web/src/components/teaser-slideshow](https://github.com/BonnierNews/dn-design-system/tree/main/web/src/components/teaser-slideshow)
 * - Storybook: [TeaserSlideshow](https://designsystem.dn.se/?path=/docs/section-teaserslideshow--docs)
 *
 * The component will not include styling by itself. Make sure to include the right styles for the component. See example below:
 * `@use '@bonniernews/dn-design-system-web/components/teaser-slideshow/teaser-slideshow.scss'`
 *
 */
export const TeaserSlideshow = ({
  theme,
  areaType,
  title,
  text,
  media,
  classNames,
  attributes = {},
}: TeaserSlideshowProps) => {
  const componentClassName = 'ds-teaser'
  const classes = formatClassString([componentClassName, 'ds-teaser--slideshow', classNames])

  return (
    <TeaserCard areaType={areaType} theme={theme} classNames={classes} attributes={attributes}>
      <Content>
        <Title title={title} /> <Body text={text} />
      </Content>

      <Media media={media} />
    </TeaserCard>
  )
}
